import React from 'react'
import { View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'

import { Button } from '../button'
import { color } from '../../theme/color'
import { StepIndicatorWizard } from '../step-indicator'

/**
 * Renders a survey `range_response` ("Scale") question: a 5-step indicator with
 * min/max labels plus a Submit button. Shared across web and native since
 * StepIndicatorWizard is cross-platform. The chosen value (1–5) is stored on the
 * question as `rangeValue` and serialized at submit time.
 */
export const ScaleChoice = observer((props: any) => {
  const { question, branding, style = {} } = props

  const customStyles = {
    stepIndicatorSize: 40,
    currentStepIndicatorSize: 40,
    separatorStrokeWidth: 3,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: '#ffffff',
    stepStrokeWidth: 3,
    stepStrokeFinishedColor: '#aaaaaa',
    stepStrokeUnFinishedColor: '#aaaaaa',
    separatorFinishedColor: '#aaaaaa',
    separatorUnFinishedColor: '#aaaaaa',
    stepIndicatorFinishedColor: '#151E23',
    stepIndicatorUnFinishedColor: '#151E23',
    stepIndicatorCurrentColor: branding.accent_color ?? '#00CB76',
    stepIndicatorLabelFontSize: 13,
    currentStepIndicatorLabelFontSize: 15,
    stepIndicatorLabelCurrentColor: '#ffffff',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: '#ffffff',
    labelColor: branding.text_color ?? '#ffffff',
    labelSize: 13,
    labelAlign: 'flex-end',
    currentStepLabelColor: branding.text_color ?? '#ffffff',
    cursor: 'pointer !important',
  }

  const handleSubmit = () => {
    if (question.answered || !question.rangeValue) {
      return
    }
    question.answer()
  }

  return (
    <View style={{ ...CONTAINER, ...style }} pointerEvents={question.answered ? 'none' : 'auto'}>
      <View style={{ paddingVertical: 40, cursor: 'pointer' }}>
        <StepIndicatorWizard
          stepCount={5}
          customStyles={customStyles}
          labels={[question.min_label, '', '', '', question.max_label]}
          setValue={question.setRangeValue}
          rangeResponse={question.rangeValue}
          defaultValue={-1}
        />
      </View>
      <Button
        style={{ backgroundColor: branding.accent_color }}
        disabled={!question.rangeValue}
        styleOverrides={!question.rangeValue ? { backgroundColor: 'rgb(31,53,116)' } : undefined}
        textStyle={{ color: color.white }}
        fullWidth
        tx="Common.submit"
        onPress={handleSubmit}
      />
    </View>
  )
})

const CONTAINER: ViewStyle = {
  maxWidth: 800,
  width: '100%',
  alignSelf: 'center',
  gap: 16,
  justifyContent: 'flex-end',
}
